import { Divider, Flex } from '@chakra-ui/react'

const TimelineDivider = () => {
	return (
		<Flex w="full" justifyContent="start" pl="80px">
			<Divider h="60px" w="2px" backgroundColor="gray" />
		</Flex>
	)
}

export default TimelineDivider
